import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { l_times } from '@fiverr-private/fit/icons';

import './index.scss';

const Close = ({ onClick, className, iconClassName }) => (
    <button className={classNames('modal-content-close', className)} onClick={onClick} aria-label="Close modal">
        <Icon className={classNames('close-icon', iconClassName)} size={14}>{l_times}</Icon>
    </button>
);

Close.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    iconClassName: PropTypes.string
};

export default Close;
